// extracted by mini-css-extract-plugin
export var container = "_2g-1";
export var editor = "_2g-2";
export var resizable = "_2g-3";
export var wrapper = "_2g-0";